/* src/app/job-signoff-artic/partials/job-signoff-artic-transport/job-signoff-artic-transport.component.scss */
/*# sourceMappingURL=job-signoff-artic-transport.component.css.map */
